module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "newOrder"
  }, [_c('div', {
    staticClass: "s"
  }, [_c('div', {
    staticClass: "bienvenido-admin"
  }, [_c('h2', [_vm._v("Bienvenido a Sendibox")]), _vm._v(" "), _c('p', [_vm._v("Ahora enviar y recibir es más fácil de lo que imaginas")]), _vm._v(" "), _c('div', {
    staticClass: "bienvenido-grid"
  }, [_c('div', {
    staticClass: "bienvenido-grid-content"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/welcome-bag.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Tus órdenes")]), _vm._v(" "), _c('p', [_vm._v("Gestiona las órdenes de compra durante las 24/7.")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-round btn-welcome",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.gotoPage(1)
      }
    }
  }, [_vm._v("Continuar")])])]), _vm._v(" "), _c('div', {
    staticClass: "bienvenido-grid-content"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/welcome-ship.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Tus embarques")]), _vm._v(" "), _c('p', [_vm._v("Gestiona los embarques generados las 24/7.")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-round btn-welcome",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.gotoPage(2)
      }
    }
  }, [_vm._v("Continuar")])])]), _vm._v(" "), _c('div', {
    staticClass: "bienvenido-grid-content"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/welcome-profile.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Tu perfil")]), _vm._v(" "), _c('p', [_vm._v("Gestiona tu información personal.")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-round btn-welcome",
    attrs: {
      "type": "submit",
      "id": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.gotoPage(3)
      }
    }
  }, [_vm._v("Continuar")])])]), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(14)) ? _c('div', {
    staticClass: "bienvenido-grid-content"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/welcome-users.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Usuarios")]), _vm._v(" "), _c('p', [_vm._v("Gestiona los distintos usuarios y roles del sistema.")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-round btn-welcome",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.gotoPage(4)
      }
    }
  }, [_vm._v("Continuar")])])]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07f89d78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Dashboard.vue
// module id = 1846
// module chunks = 1